import { useEffect, useState } from "react";

// ドットが増えるローディングコンポーネント
const DotLoading: React.FC<{ text?: string }> = ({ text = "処理中" }) => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? "" : prev + "."));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return <p>{text}{dots}</p>;
};

export default DotLoading;